import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { Card, Loader } from 'components';
import { useFetch } from 'hooks';
import { appService } from 'services';

const ZendeskSsoPage = () => {
  const { call } = useFetch();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('return_to')) getJwt();
  }, [searchParams]);

  const getJwt = async () => {
    const { data } =
      (await call({
        service: 'zendesk',
        method: 'post',
        path: '/zendesk'
      })) || {};

    if (data?.body?.jwt) {
      window.location.href = `https://touloisirssupport.zendesk.com/access/jwt?jwt=${
        data.body.jwt
      }&return_to=${searchParams.get('return_to')}`;
    }
  };

  return (
    <Card className="my-8 mx-auto w-[90%] md:w-[25rem]">
      <p className="text-xl text-center font-semibold flex flex-col items-center gap-4">
        <Loader loaderClass="w-5 h-5" />
        <span className="block">{t('zendeskRedirection', { brand: appService.brand() })}</span>
      </p>
    </Card>
  );
};

export default ZendeskSsoPage;
